import { Store } from '@ms/yammer-data/dist/state/types';
import { PageSectionRefsProvider } from '@ms/yammer-web-components/dist/app/PageSectionRefs';
import { ReduxTranslationsContextProvider } from '@ms/yammer-web-components/dist/translations';
import { AnnouncerProvider } from '@ms/yammer-web-core-ui/dist/components/Announcer';
import { basenameForTeamsApp, isLoadedWithWebSubdomain } from '@ms/yammer-web-support/dist/location';
import AppError, { AppErrorBoundary } from 'components/AppError';
import React, { FC } from 'react';
import { HelmetProvider } from 'react-helmet-async';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { YammerTeamsState } from 'state/types';

import App from '../App';

import { applyMainStyles } from './Main.styles';

interface MainProps {
  readonly store: Store<YammerTeamsState>;
  readonly error: unknown;
}

const Main: FC<MainProps> = ({ store, error }) => {
  const routeBasename = isLoadedWithWebSubdomain() ? basenameForTeamsApp : '';
  const children =
    error != null ? (
      <AppErrorBoundary>
        <AppError error={error} />
      </AppErrorBoundary>
    ) : (
      <App />
    );

  applyMainStyles();

  return (
    <Provider store={store}>
      <ReduxTranslationsContextProvider>
        <HelmetProvider>
          <BrowserRouter basename={routeBasename}>
            <PageSectionRefsProvider>
              <AnnouncerProvider>{children}</AnnouncerProvider>
            </PageSectionRefsProvider>
          </BrowserRouter>
        </HelmetProvider>
      </ReduxTranslationsContextProvider>
    </Provider>
  );
};

export default Main;
